import {
  Box,
  Heading,
  Dialog,
  Button,
  Spinner,
  ButtonGroup,
} from "@chakra-ui/react";

import { InvoiceTemplateForm } from "../InvoiceTemplateForm";
import {
  useInvoiceTemplate,
  useInvoiceTemplateDelete,
} from "../../../../hooks/useInvoiceTemplate";
import { useParams } from "react-router-dom";
import { NotFound } from "../../../../404";
import { useRef, useState } from "react";

export default function InvoiceTemplateEditPage() {
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const cancelRef = useRef(null);
  const invoiceTemplatePk = parseInt(id || "0", 10);
  const invoiceTemplateQuery = useInvoiceTemplate(invoiceTemplatePk);
  const invoiceTemplateDelete = useInvoiceTemplateDelete();

  if (invoiceTemplateQuery.isLoading) {
    return <Spinner />;
  }

  if (!id || !invoiceTemplateQuery.data) {
    return <NotFound />;
  }

  return (
    <Box>
      <Heading as="h1" mb={4}>
        Endre fakturamal
      </Heading>
      <InvoiceTemplateForm invoiceTemplate={invoiceTemplateQuery.data} />
      <Button colorPalette="red" mt={8} onClick={() => setOpen(true)}>
        Slett fakturamal
      </Button>
      <Dialog.Root open={open} onOpenChange={(e) => setOpen(e.open)} role="alertdialog">
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header fontSize="lg" fontWeight="bold">
              Slette fakturamal
            </Dialog.Header>

            <Dialog.Footer>
              {invoiceTemplateDelete.isPending && <Spinner />}
              {!invoiceTemplateDelete.isPending && (
                <ButtonGroup>
                  <Button ref={cancelRef} onClick={() => setOpen(false)}>
                    Avbryt
                  </Button>
                  <Button
                    colorPalette="red"
                    onClick={() => {
                      invoiceTemplateDelete.mutate({ invoiceTemplatePk });
                    }}
                    ml={3}
                  >
                    Slett
                  </Button>
                </ButtonGroup>
              )}
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Dialog.Root>
    </Box>
  );
}
